import React, { useRef, useState } from "react";
import axios from 'axios';
import {axiosEH} from './common/functions'
import jwtUser from '../jwtUser';

export default function Textbooks() {
  // 1. 1st-level vars
  const firstLanguage = sessionStorage.getItem("firstLanguage")
  const [statusMsg, setStatusMsg] = useState('');
  let [tbList, setTbList] = useState([{}]); // no added header

  let currentBId, lastBId, currentUId = "", lastUId; 
  let tbHeaders, tbRows;
  const tbodyID="tb-table";
  const tbTable = document.getElementById(tbodyID);
  const selectedClass = sessionStorage.getItem("selectedClassname")

  const NSNAME = selectedClass?'National standards 2022': 'defaultClass contents'
  const ESNAME = 'Elementary school';
  const MSNAME = 'Middle school';
  const HSNAME = 'High school';
  const NSUID = process.env.REACT_APP_NSUID;
  
  const NSFC = process.env.REACT_APP_NSFC
  const NSES = process.env.REACT_APP_NSES
  const NSMS = process.env.REACT_APP_NSMS
  const NSHM = process.env.REACT_APP_NSHM
  const NSHSM = process.env.REACT_APP_NSHSM
  //const NSFC = 'Flashcard 2025', NSES = 'ES 2022 SB', NSMS = 'MS 2022 SB', NSHM = 'HM 2020 SB', NSHSM = 'HSM 2020 SB';
  //const NSFC = 'Flashcards 2025', NSES = 'Grades 1-6 SB', NSMS = 'Grades 7-9 SB', NSHM = 'High school-M SB', NSHSM = 'High school-SM SB';

  // TB class 3 params: the last values
  const schoolID = useRef(sessionStorage.getItem("schoolID")?sessionStorage.getItem("schoolID"): "HS");
  const pressID = useRef(sessionStorage.getItem("schoolID")?sessionStorage.getItem("pressID"): "RJB");
  const buIDstr = sessionStorage.getItem("schoolID")?sessionStorage.getItem("buIDstr"):process.env.REACT_APP_buIDstr
  const buIDarr = useRef(buIDstr.split(','));

  const tbTOCprof = [
    {'bookID':NSNAME, unitID: ''},
    {'bookID':NSFC, unitID: NSUID},
    {'bookID':NSES, unitID: NSUID},
    {'bookID':NSMS, unitID: NSUID},
    {'bookID':NSHM, unitID: NSUID},
    {'bookID':NSHSM, unitID: NSUID},
  ];

  try {
    const user = jwtUser(); // get user token
  
    // ---- f()
    function newTextbooks() {
      let isNewTextbooks = false;
      const isTBloaded = sessionStorage.getItem("schoolID")

      if (firstLanguage == "simplified-Chinese" && selectedClass !=null && isTBloaded == null ) {
        isNewTextbooks = true;
      } else if (firstLanguage == "simplified-Chinese" && selectedClass ==null ){
        setStatusMsg('You can go Classes menu and select your class to replace the defaultClass');
      }
      console.log("isNewTextbooks: ", isNewTextbooks)
      return isNewTextbooks
    }

    function getSchoolName(){
      let sn = '';

      if (schoolID.current == 'ES'){
        sn = ESNAME + '-' + pressID.current;
      } else if (schoolID.current == 'MS'){
        sn = MSNAME  + '-' + pressID.current;
      } else if (schoolID.current == 'HS'){
        sn = HSNAME + '-' + pressID.current;
      }
      return sn;
    }

    function getTOCtb(sName){ 
      const arr = [ {'bookID':NSNAME, unitID: ''}, {'bookID':sName, unitID: ''}];
      for (let i=0; i< buIDarr.current.length; i++){
        arr.push({'bookID': buIDarr.current[i].split('-')[0], unitID: ''})          
      }
      return arr;
    }

    function getUIDArr(bId){
      let arr = [];
      const index = buIDarr.current.findIndex(str=>{
        if(str.includes(bId)) return str;
      })
      //console.log('bId, buIDarr,index: ', bId, buIDarr.current,index);
      const beginUnit = buIDarr.current[index].split("-")[1];
      const endUnit = buIDarr.current[index].split("-")[2];

      for (var i = parseInt(beginUnit); i <= parseInt(endUnit); i++) {
        arr.push( {'bookID':bId, unitID: i} );
      }
      return arr;
    }

    function initTOC(){
      const schoolName = getSchoolName();
      let tempArr = [...tbTOCprof];

      tempArr.push({'bookID':schoolName, unitID: ''})
      setTbList(tempArr);
    }

    function tbUpdate(bId){
      const schoolName = getSchoolName();
      let tempArr = [...tbTOCprof];

      tempArr.push({'bookID':schoolName, unitID: ''})

      // open 1st or 2nd level
      if ( bId == NSNAME || bId == NSFC || bId == NSES || bId == NSMS || bId == NSHM || bId == NSHSM) {
        tempArr = [...tbTOCprof];
        tempArr.push({'bookID':schoolName, unitID: ''})
        setTbList(tempArr);
      } else if ( bId == schoolName) {
        tempArr = getTOCtb(schoolName, buIDarr.current);
        setTbList(tempArr);
      } else {  // unit level
        tempArr = getTOCtb(schoolName, buIDarr.current);
        const index = tempArr.findIndex(obj=>{
          if(obj.bookID.includes(bId)) return obj;
        })
        const unitIdArr = getUIDArr(bId);
        tempArr = tempArr.toSpliced(index, 1, ...unitIdArr);  // a.splice() error
        setTbList(tempArr);
      }
    }

    function addTask(url, buID, tType) {
      let classname ="", taskDueDays =7, spellingTimeoutSec =15;
      if (firstLanguage != "simplified-Chinese" || selectedClass ==null ) {
        classname = localStorage.getItem("selectedClassname")
        taskDueDays = localStorage.getItem("sc-taskDueDays")
        spellingTimeoutSec = localStorage.getItem("sc-spellingTimeoutSec")
      } else {
        classname = selectedClass;
        taskDueDays = sessionStorage.getItem("sc-taskDueDays")
        spellingTimeoutSec = sessionStorage.getItem("sc-spellingTimeoutSec")
      }

      axios.post(url, {
        username: user.username,
        className: classname,
        pressID: pressID.current,
        bookUnitID: buID,   //'demottps-G3-1-U1',
        Type: tType,
        firstLanguage: firstLanguage,
        taskDueDays: taskDueDays,
      }, { headers: { 'x-access-token': user['x-access-token'] } })
        .then(res => {
          if (res.data.includes('success')){
            window.location.href = '/task'
          } else {
            setStatusMsg(res.data);
          }
        })
        .catch(err => { 
          setStatusMsg(axiosEH(err)); 
        })
    }

    async function getTextbooks() {
      const url = process.env.REACT_APP_BASEURL + '/textbooks/?cn=' + selectedClass;
      const res = await axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } })
      // "ES,PEP,3A 2024-1-6,3B 2024-1-6,4A 2013-1-6,4B 2013-1-6,5A 2013-1-6,5B 2013-1-6,6A 2013-1-6,6B 2013-1-4"
      if (typeof (res.data) == 'object') {
        setStatusMsg(res.data.info);

      } else {
        res.data = res.data.split(',')
        schoolID.current = res.data.shift()
        pressID.current  = res.data.shift()
        buIDarr.current  = ([...res.data])
        sessionStorage.setItem("schoolID", schoolID.current)
        sessionStorage.setItem("pressID", pressID.current)
        sessionStorage.setItem("buIDstr", buIDarr.current)
        initTOC();
        setStatusMsg('');
      }
    } // end of f() -------

    // loop of table process, 3 click cases
    //let nextRow;  
    if (tbTable != null) { // not 1st rend
      tbTable.addEventListener('click', function (event) {	// 1-click, 'dblclick'
        //event.preventDefault();
        //event.stopPropagation();
        event.stopImmediatePropagation();

        var tr = tbTable.rows[0];
        var cll = tr.cells[0];
        var cellText = cll.innerText;
  
        const cell = event.target.closest('td');
        if (!cell) {return;} // Quit, not clicked on a cell: 0%  
        const row = cell.parentElement;
        //var nextRow = tbTable.rows[row.rowIndex +1];
        lastBId = currentBId;
        lastUId = currentUId;
        currentBId = row.cells[0].innerHTML;
        currentUId = row.cells[1].innerHTML;

        if (cell.cellIndex ==0 ) {  //case 1: open book
          console.log('case 1: clicked cell-0 :', row.rowIndex, cell.cellIndex);
          //if (lastBId != currentBId) {
            sessionStorage.setItem('currentBId', currentBId);
            sessionStorage.setItem('lastBId', lastBId);
            tbUpdate(currentBId);
          //}

        } else if (currentUId !='' ){ //case 2: +task 
          if ((lastUId != currentUId) || (lastBId != currentBId)) {
            let taskType = process.env.REACT_APP_NS_TASKTYPE;
            let url = "";
            if (currentUId !=NSUID) {
              url = process.env.REACT_APP_BASEURL + '/usertasks/assigntask';
              taskType =sessionStorage.getItem('sc-tbTaskType');
              if(taskType == null){
                taskType = process.env.REACT_APP_TB_DEFAULT_TASKTYPE
              }
            } else {
              if(currentBId.includes(process.env.REACT_APP_FC_PREFIX)) taskType ="FS"
              url = process.env.REACT_APP_BASEURL + '/userprofiles/assigntask';                
            }
            addTask(url, `${currentBId}-${currentUId}`, taskType);
          }
        } else {
          console.log('case 3: clicked cell-1 & empty currentUId:', row.rowIndex, cell.cellIndex, currentUId)
        }
      });
    } else {
      console.log('tbTable ==null: error')
    }

    tbHeaders = Object.keys(tbList[0]);
    tbRows = tbList.map(item => Object.values(item));

    React.useEffect(() => {
      if (newTextbooks() == true) {
        getTextbooks();
      } else {
        initTOC();
      }
   }, [schoolID.current]);   // []: render once only

  }
  catch (err) {
    setStatusMsg(err.message);
  }

  return (
    <section >
      { tbList.length && <div className="taskList mx-5">
        {/* tbList.length > 0 && <TableComp data={tbList} tbodyID="tb-table" /> */}
        <p style={{color: 'grey'}}><b>Click</b> the unitID column content to add task(s)</p>
        <p style={{color: 'grey'}}><b>Click</b> the bookID column content to open this book when the unitID content is blank</p>
        <table>
          <thead>
            <tr>
              {tbHeaders.map(header => <th key={header}>{header}</th>)}
            </tr>
          </thead>
          <tbody id={tbodyID}>
            {tbRows.map((row, index) => (
              <tr key={index}>
                {row.map((cell, index) => <td key={index}>{cell}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div> }
      <label className="label has-text-success">{statusMsg}</label>
      <br></br>
    </section>
  );
}